import { getRoute, reactLazyImport } from "helpers";
import FrontendLayout from "pages/frontend/FrontendLayout";
import { MODULE_FOLDER, MODULE_PREFIX } from "./constants";

const PVSActivities = reactLazyImport(
  "/pages/PVSActivities",
  "PVSActivities",
  MODULE_FOLDER
);
const ReportTemplatesIndex = reactLazyImport(
  "/pages/forms/Index",
  "ReportTemplatesIndex",
  MODULE_FOLDER
);
const ReportTemplatesCreate = reactLazyImport(
  "/pages/forms/Create",
  "ReportTemplatesCreate",
  MODULE_FOLDER
);
const ReportTemplatesEdit = reactLazyImport(
  "/pages/forms/Edit",
  "ReportTemplatesEdit",
  MODULE_FOLDER
);
const FormRules = reactLazyImport(
  "/pages/forms/Rules",
  "FormRules",
  MODULE_FOLDER
);
const ReportTemplatesPreview = reactLazyImport(
  "/pages/forms/Preview",
  "ReportTemplatesPreview",
  MODULE_FOLDER
);
const ReportTemplatesDataEntry = reactLazyImport(
  "/pages/forms/DataEntry",
  "ReportTemplatesDataEntry",
  MODULE_FOLDER
);
const ReportTemplatesEditor = reactLazyImport(
  "/pages/forms/Editor",
  "ReportTemplatesEditor",
  MODULE_FOLDER
);

const router = {
  3: [
    getRoute({
      path: `/portal/${MODULE_PREFIX}`,
      element: <FrontendLayout children={<PVSActivities />} secure={true} />,
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library`,
      element: (
        <FrontendLayout children={<ReportTemplatesIndex />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/create`,
      element: (
        <FrontendLayout children={<ReportTemplatesCreate />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/edit`,
      element: (
        <FrontendLayout children={<ReportTemplatesEdit />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/rules`,
      element: (
        <FrontendLayout children={<FormRules />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/preview/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesPreview />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/editor/:ssid?/:sstype?`,
      element: (
        <FrontendLayout children={<ReportTemplatesEditor />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform-view/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry isReadOnly={true} />} secure={true} />
      ),
    }),
  ],
  5: [
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry />} secure={true} />
      ),
      
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform-view/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry isReadOnly={true} />} secure={true} />
      ),
    }),
  ],
  21: [
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform-view/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry isReadOnly={true} />} secure={true} />
      ),
    }),
  ],
  14: [
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/dform-view/:id/:movementId/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesDataEntry isReadOnly={true} />} secure={true} />
      ),
    }),
  ],
  4: [
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library`,
      element: (
        <FrontendLayout children={<ReportTemplatesIndex />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/create`,
      element: (
        <FrontendLayout children={<ReportTemplatesCreate />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/edit`,
      element: (
        <FrontendLayout children={<ReportTemplatesEdit />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/rules`,
      element: (
        <FrontendLayout children={<FormRules />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/preview/:sectionId?`,
      element: (
        <FrontendLayout children={<ReportTemplatesPreview />} secure={true} />
      ),
    }),
    getRoute({
      path: `/portal/${MODULE_PREFIX}/template-library/:id/editor/:ssid?/:sstype?`,
      element: (
        <FrontendLayout children={<ReportTemplatesEditor />} secure={true} />
      ),
    }),
  ]
};

export default router;
